import { CaseClosingConfigurationDto } from 'types/caseClosing';
import { t } from 'utils/getTranslations';
import { CaseClosingSubsection, CaseClosingTick } from './CaseClosingSubsection';
import { useCaseClosingSubsectionEdit } from './useCaseClosingSubsectionEdit';

interface Props {
    caseClosing: CaseClosingConfigurationDto;
}

export function ConfidentialCasesSubsection({ caseClosing }: Props) {
    const { isEditMode, isSaving, startEditing, cancel, change, valueOf, save } =
        useCaseClosingSubsectionEdit(caseClosing);

    return (
        <CaseClosingSubsection
            titleId="case-closing-config.confidential-cases"
            isEditMode={isEditMode}
            isSaving={isSaving}
            onEdit={startEditing}
            onCancel={cancel}
            onSave={() => {
                void save();
            }}
        >
            <CaseClosingTick
                label={t('case-closing-config.require-confidential-reason')}
                helperText={t('case-closing-config.require-confidential-reason-helper')}
                checked={valueOf('isConfidentialReasonRequired')}
                disabled={!isEditMode}
                onCheckedChange={(checked) => change({ isConfidentialReasonRequired: checked })}
            />
        </CaseClosingSubsection>
    );
}
